export default __webpack_public_path__ + "static/media/skillshare.6737c739.webp";